import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';

function getPublishToSalesforceConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: 'exp',
    httpMethod: 'GET',
    endpoint: 'getSalesforceApps',
  };
}

export interface ISalesforceApp {
  readonly id: string;
  readonly label: string;
  readonly name: string;
  readonly namespace: string;
  readonly type: string;
  readonly url: string;
  readonly isPrivateApp?: boolean; // If flag isn't set then we treat the app as public
}

export interface IGetSalesforceAppResult {
  salesforceApps: {
    nextPageToken: string;
    salesforceApp: ISalesforceApp[];
  };
}

export type getSalesforceAppParams = {
  readonly oauthId: string;
  readonly nextPageToken?: string;
}

export class GetSalesforceAppsService {
  public static callViaApiService(queryParams: getSalesforceAppParams) {
    return makeJsonRestApiRequest<void, IGetSalesforceAppResult>({
      config: getPublishToSalesforceConfig(),
      request: null,
      queryParams
    });
  }
}